import { t } from '../../../../../services/texts.service';
import { createElementHook, createControlHook, createLeafComponent } from '@react-leaflet/core';
import type { LeafletContextInterface } from '@react-leaflet/core';
import L from 'leaflet';

interface MapSettingsControlProps {
  className: string;
  position?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
  onClick?: (event: MouseEvent) => void;
}

function createMapSettingsControl({ className, position = 'topleft', onClick }: MapSettingsControlProps, context: LeafletContextInterface) {
  const controlInstance = new L.Control({ position });

  controlInstance.onAdd = () => {
    const div = L.DomUtil.create('div', `leaflet-bar ${className ?? ''}`);
    const hyperlink = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single w-auto px-2');
    hyperlink.href = '#';
    hyperlink.setAttribute('role', 'button');
    hyperlink.onclick = (e) => {
      e.preventDefault();
      onClick?.(e);
    };
    const label = L.DomUtil.create('span', 'leaflet-control-filter-icon d-flex align-items-center gap-1', hyperlink);
    label.textContent = t('Filter', 'Filter');
    div.appendChild(hyperlink);
    return div;
  };

  return { instance: controlInstance, context };
}

function updateMapSettingsControl(instance: L.Control, props: MapSettingsControlProps, prevProps: MapSettingsControlProps) {
  if (props.className === prevProps.className) return;
  const container = instance.getContainer();
  if (!container) return;
  const prev = prevProps.className?.split(' ').filter(Boolean) ?? [];
  const next = props.className?.split(' ').filter(Boolean) ?? [];
  if (prev.length) container.classList.remove(...prev);
  if (next.length) container.classList.add(...next);
}

const useMapSettingsControlElement = createElementHook(createMapSettingsControl, updateMapSettingsControl);
const useMapSettingsControl = createControlHook(useMapSettingsControlElement);
const MapSettingsControlComponent = createLeafComponent(useMapSettingsControl);

export default MapSettingsControlComponent;
